export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item'
}
export const url = 'https://smro.thingcom.com/blade-visual'